import { render, staticRenderFns } from "./addNewSignature.vue?vue&type=template&id=0c1609ba&scoped=true"
import script from "./addNewSignature.vue?vue&type=script&lang=js"
export * from "./addNewSignature.vue?vue&type=script&lang=js"
import style0 from "./addNewSignature.vue?vue&type=style&index=0&id=0c1609ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1609ba",
  null
  
)

export default component.exports